import React from "react";
import './cms-button.css';

type CMSButtonProps = {
    text: string;
    iconSrc?: string;
    type?: 'white' | 'pink' | 'purple' | 'blue';
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    htmlType?: 'button' | 'submit' | 'reset';
    style?: React.CSSProperties;
};

export const CMSButton = ({ text, iconSrc, type = 'pink', onClick, htmlType = 'button', style }: CMSButtonProps) => {
    const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        if (onClick) onClick(e);
    };
    
    return (
        <button className={`cms-button ${ type }`} onClick={handleClick} type={htmlType} style={style}>
            <div className="d-flex align-items-center justify-content-center">
                { iconSrc && <><img src={iconSrc} alt="add-button-icon" />&nbsp;&nbsp;</> }
                <span>{text}</span>
            </div>
        </button>
    );
};